import { PropsWithChildren } from 'react';

import { UnboaredSpinner } from '../../components/design/spinners/UnboaredSpinner';

import styles from './LoadingPage.module.css';

export type LoadingPageProps = PropsWithChildren;

export function LoadingPage({ children }: LoadingPageProps) {
    return (
        <div className={styles.root}>
            <UnboaredSpinner />
            <p className={styles.text}>{children}</p>
        </div>
    );
}
